import { Loading } from 'element-ui';
import moment from 'moment';
import { mapActions } from 'vuex';


const utilityFunctionsMix = {
  data() {
    return {
      loaderWithTextObj: {
        loading: null,
        loaderTimeOut: null,
      },
    };
  },

  computed: {

  },

  methods: {
    ...mapActions('selectdate', ['getYear', 'getMonth', 'getYear2', 'getMonth2', 'setStartDate', 'setEndDate', 'setStartMonth', 'setEndMonth', 'setStartYear', 'setEndYear', 'triggerDateChange']),

    currFormatWithDollarHighlighted(amount) {
      const formatedAmount = amount.toLocaleString(undefined,
        { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const firstPart = formatedAmount.slice(0, -3);
      const fractionPart = formatedAmount.slice(-2);
      return `<span class="mainPart">$ ${firstPart}</span>.<span class="fractionPart">${fractionPart}</span>`;
    },
    // On stop event, hide loader.
    stopLoaderWithText() {
      clearTimeout(this.loaderWithTextObj.loaderTimeOut);
      if (this.loaderWithTextObj.loading) {
        this.loaderWithTextObj.loading.close();
      }
      this.loaderWithTextObj = {
        loading: null,
        loaderTimeOut: null,
      };
    },
    // Starts loader
    startLoaderWithText(text) {
      this.loaderWithTextObj.loading = Loading.service({
        lock: true,
        text: '',
        spinner: 'preloader',
      });
      this.loaderWithTextObj.loaderTimeOut = setTimeout(() => {
        // Aftrer 2 seconds displayes text.
        this.loaderWithTextObj.loading.close();
        this.loaderWithTextObj.loading = Loading.service({
          lock: true,
          text,
          spinner: 'preloader',
        });
      }, 2000);
    },
    // Converts selcted date range to brower timezone date range before passing to API server.
    getDateInLocalZone(dateRangeObj) {
      let expenseDateGte = moment(dateRangeObj.startDate).format('YYYY-MM-DD');
      expenseDateGte = moment(`${expenseDateGte}T00:00:00`).local();
      let expenseDateLte = moment(dateRangeObj.endDate).format('YYYY-MM-DD');
      expenseDateLte = moment(`${expenseDateLte}T23:59:00`).local();
      return { expenseDateGte, expenseDateLte };
    },
  },
};

export default utilityFunctionsMix;
